import { KatalComponent } from '../../shared/base';
import { getFirstMatchingParent } from '../../shared/utils';

/**
 * @component {kat-popover-hide} KatalPopoverHide A simple wrapper element that binds a click event and closes the popover.
 */
class KatalPopoverHide extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatalPopoverHide.observedAttributes);
    this.addEventListener('click', evt => {
      const popover = getFirstMatchingParent(
        this,
        ele => ele.tagName === 'KAT-POPOVER'
      );
      if (popover) {
        popover.hide();
      }
    });
  }
}

KatalComponent.register('kat-popover-hide', KatalPopoverHide);
